import { Navigate, createBrowserRouter } from 'react-router-dom';
import { UserAuthGuard } from '@/components/UserAuthGuard';
import FarmersLayout from '@/layouts/farmers/FarmersLayout';
import SimpleLayout from '@/layouts/simple/SimpleLayout';
import App from '@/pages/App';
import {
  ContractsPage,
  DocumentsLayout,
  DocumentsPage,
  InvoicesPage,
  OrdersPage,
  SingleInvoice,
} from '@/pages/FarmerPages/DocumentsPages/';
import { SingleOrder } from '@/pages/FarmerPages/DocumentsPages/SingleOrder';
import {
  CategoryPage,
  CheckoutPage,
  EnrolePage,
  ItemPage,
  RetailerHomePage,
  RetailerPage,
} from '@/pages/FarmerPages/FarmerRetailerPages';
import { FarmersHomePage } from '@/pages/FarmerPages/FarmersHomePage';
import { MyFarmPage } from '@/pages/FarmerPages/MyFarmPage';
import { OrderSuccessPage } from '@/pages/FarmerPages/OrderSuccessPage';
import { PricesPage } from '@/pages/FarmerPages/PricesPage';
import { Page404 } from '@/pages/Page404';
import { LoginPage, ProfilePage } from '@/pages/UserPages';

export default createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        element: <SimpleLayout />,
        children: [
          { path: '404', element: <Page404 /> },
          { path: '*', element: <Navigate to="/404" /> },
        ],
      },
      {
        path: '/redirect',
        element: <Navigate to="/" replace />,
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        element: <FarmersLayout />,
        children: [
          {
            element: <UserAuthGuard />,
            children: [
              {
                element: <FarmersHomePage />,
                path: '/',
              },
              {
                path: '/profile',
                element: <ProfilePage />,
              },
              { path: 'prices', element: <PricesPage /> },
              {
                path: 'farm',
                element: <MyFarmPage />,
              },
              {
                element: <DocumentsLayout />,
                children: [
                  {
                    path: 'documents/:retailerId/orders',
                    element: <OrdersPage />,
                  },
                  {
                    path: 'documents/:retailerId/orders/:orderId',
                    element: <SingleOrder />,
                  },
                  {
                    path: 'documents/:retailerId/documents',
                    element: <DocumentsPage />,
                  },
                  {
                    path: 'documents/:retailerId/invoices',
                    element: <InvoicesPage />,
                  },
                  {
                    path: 'documents/:retailerId/invoices/:invoiceId',
                    element: <SingleInvoice />,
                  },
                  {
                    path: 'documents/:retailerId/contracts/',
                    element: <ContractsPage />,
                  },
                ],
              },
              {
                path: '/order/:orderId/success',
                element: <OrderSuccessPage />,
              },
              { path: '/:retailerId', element: <RetailerPage /> },
              { path: '/:retailerId/info', element: <RetailerHomePage /> },
              { path: '/:retailerId/checkout', element: <CheckoutPage /> },
              { path: '/:retailerId/enrole', element: <EnrolePage /> },
              { path: '/:etailerId/item/:itemId', element: <ItemPage /> },
              { path: '/:retailerId/:category', element: <CategoryPage /> },
              {
                path: '/:retailerId/*',
                element: <Navigate to="/404" replace />,
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/404" replace />,
      },
    ],
  },
]);
